var BaseUi = function () {

    var global = function () {
        $('a, button, img, label').click(function () {
            $(this).blur();
        });
    };
    
    // zobrazot více o lékaři
    // dělá odskočení obsahu, aby absolutní box nepřekrýval lékaře
    // o samotné otevření a zavření se js nestará!
    var person = function () {
        var $lastDetail;
        
        if($('.js-person').length) {
            $('.js-person-check').change(function () {                
                var $item = $(this).closest('.js-person');
                var $detail = $item.find('.js-person-detail');
                var detailHeight = $detail.outerHeight(); 
                
                if ($lastDetail) {
                    $lastDetail.css('margin-bottom', 0);
                }   
                
                $item.css('margin-bottom', detailHeight);
                $lastDetail = $item;
            });
        }
    };
    
    // PŘEPÍNÁNÍ OBSAHU
    // funguje pouze jednou na stránce
    // dá se ovládat jak odkazy tak selectboxem 
    // momentální využití na detailu léku
    var chapters = function () {
        var $openLink = $('[data-chapters-open]');
        var $openSelect = $('.js-chapters-select');
        
        var open = function (id) {
            $openLink.removeClass('is-active').filter('[data-chapters-open="' + id + '"]').addClass('is-active');
            $('[data-chapters]').addClass('hidden').filter('[data-chapters="' + id + '"]').removeClass('hidden');
            $openSelect.val(id);
        };
        
        $openLink.click(function () {
            open($(this).data('chapters-open'));
            return false;
        });
        
        $openSelect.change(function () {
            open($(this).find('option:selected').val());
        });
    };
    
    // jak to jen popsat
    // syns aktivní třídy dvou elementů podle data attr
    var activeSync = function () {
        var syncId; 
        $( "[data-active-sync]" ).hover(
            function() {
                syncId = $(this).data('active-sync');
                $('[data-active-sync="' + syncId + '"]').addClass('is-active');
            }, function() {
                $('[data-active-sync="' + syncId + '"]').removeClass('is-active');
            }
        );
    };
    
    // Facebook like lazy loading
    
    var fbLike = function () {
        var $like = $('.fb-like').eq(0);
        
        if($like.is(':visible')) {                                  
            var likePosition = $like.offset().top - $like.outerHeight() - $(window).height();

            var facebookLazyLoad = function () {
                if ($(window).scrollTop() > likePosition) {
                    $(window).off("scroll", facebookLazyLoad);

                    $like.parent().append('<div id="fb-root"></div>');
                    
                    (function(d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) return;
                        js = d.createElement(s); js.id = id;
                        js.src = "//connect.facebook.net/cs_CZ/sdk.js#xfbml=1&version=v2.9";
                        fjs.parentNode.insertBefore(js, fjs);
                    }(document, 'script', 'facebook-jssdk'));
                }
            };
            
            $(window).on("scroll", facebookLazyLoad);
        }
    };
    
    var menuMoreLink = function () {
        $('#js-menu-more-link').click(function () {
            return false;
        });
    };

    var scrollTo = function() {
        var scrollElements = $('[data-scroll-here]');
        if (scrollElements.length > 0) {
			$('html, body').animate({
				scrollTop: scrollElements.first().offset().top
			}, 1000);
        }
    };

    var init = function () {
        global();
        person();
        chapters();
        activeSync();
        fbLike();
        menuMoreLink();
        scrollTo();
    };

    return {
        init: init
    };
}();

UL.register(BaseUi);
